export const maltaUniversities = {
  "university-of-malta": {
    slug: "university-of-malta", country: "malta",
    name: "University of Malta", shortName: "UM", flag: "🇲🇹",
    city: "Msida", founded: 1592, qsRank: "#851+ QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Malta’s flagship public university and the country’s most recognised institution, offering strong programmes in medicine, engineering, IT, law, and business.",
    tuition: { domestic: "€400–€2,000/yr", international: "€8,000–€14,000/yr" },
    living: "€700–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MSc Computer Science", duration: "2 years", language: "English" },
      { name: "MBA", duration: "1.5 years", language: "English" },
      { name: "MSc Data Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€28,000–€45,000", topEmployers: ["GO plc", "Betsson", "HSBC Malta"] },
    intakes: ["October", "February"], istpStudents: 14,
  },

  "malta-college-of-arts-science-technology": {
    slug: "malta-college-of-arts-science-technology", country: "malta",
    name: "Malta College of Arts, Science & Technology", shortName: "MCAST", flag: "🇲🇹",
    city: "Paola", founded: 2001, qsRank: "#National Leading Institute",
    heroImg:
      "https://images.unsplash.com/photo-1562774053-701939374585?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",
    overview: "Top vocational and applied sciences institution in Malta with industry-linked programmes.",
    tuition: { domestic: "€1,000–€3,000/yr", international: "€6,000–€10,000/yr" },
    living: "€650–€1,000/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "MSc Engineering Management", duration: "2 years", language: "English" },
      { name: "MSc ICT", duration: "2 years", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€26,000–€42,000", topEmployers: ["Maltacom", "Gaming Firms", "Local Industry"] },
    intakes: ["October", "February"], istpStudents: 10,
  },

  "american-university-of-malta": {
    slug: "american-university-of-malta", country: "malta",
    name: "American University of Malta", shortName: "AUM", flag: "🇲🇹",
    city: "Cospicua", founded: 2016, qsRank: "#Private University",
    heroImg: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=900&auto=format&fit=crop",
    overview: "Modern private university with US-style curriculum focused on business, engineering, and entrepreneurship.",
    tuition: { domestic: "€7,000–€10,000/yr", international: "€8,000–€12,000/yr" },
    living: "€700–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MBA", duration: "2 years", language: "English" },
      { name: "BSc Civil Engineering", duration: "4 years", language: "English" },
      { name: "BBA", duration: "3 years", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€28,000–€40,000", topEmployers: ["Private Firms", "Consultancies"] },
    intakes: ["September", "January"], istpStudents: 6,
  },

  "global-college-malta": {
    slug: "global-college-malta", country: "malta",
    name: "Global College Malta", shortName: "GCM", flag: "🇲🇹",
    city: "SmartCity", founded: 2013, qsRank: "#Private Institute",
    heroImg:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",
    overview: "Known for MBA and executive education with international faculty exposure.",
    tuition: { domestic: "€8,000+/yr", international: "€9,000–€15,000/yr" },
    living: "€700–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€30,000–€48,000", topEmployers: ["Finance Firms", "Gaming Companies"] },
    intakes: ["October", "February"], istpStudents: 5,
  },

  "london-school-of-commerce-malta": {
    slug: "london-school-of-commerce-malta", country: "malta",
    name: "London School of Commerce Malta", shortName: "LSC Malta", flag: "🇲🇹",
    city: "Floriana", founded: 2014, qsRank: "#Private Institute",
    heroImg:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Affordable management and business education with UK-linked pathways.",
    tuition: { domestic: "€6,000+/yr", international: "€7,000–€11,000/yr" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "BBA", duration: "3 years", language: "English" },
    ],
    placementStats: { rate: "84%", avgSalary: "€26,000–€40,000", topEmployers: ["Retail", "SMEs", "Hospitality"] },
    intakes: ["January", "October"], istpStudents: 4,
  },

  "queen-mary-university-malta-centre": {
    slug: "queen-mary-university-malta-centre", country: "malta",
    name: "Queen Mary University Malta Centre", shortName: "QMUL Malta", flag: "🇲🇹",
    city: "Gozo", founded: 2017, qsRank: "#Global Partner Campus",
    heroImg:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=900&auto=format&fit=crop",
    overview: "Medical education centre linked with UK university standards.",
    tuition: { domestic: "€10,000+/yr", international: "€18,000–€30,000/yr" },
    living: "€750–€1,100/mo", ielts: "6.5+", gre: "Not Required",
    topCourses: [
      { name: "MBBS / Medicine", duration: "5 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "High sector dependent", topEmployers: ["Hospitals", "Clinics"] },
    intakes: ["September"], istpStudents: 2,
  },

  "learn-key-institute-malta": {
    slug: "learn-key-institute-malta", country: "malta",
    name: "Learn Key Institute Malta", shortName: "LKI", flag: "🇲🇹",
    city: "Sliema", founded: 2012, qsRank: "#Training Institute",
    heroImg:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?q=80&w=900&auto=format&fit=crop",
    overview: "Career-focused institute offering business and IT programmes.",
    tuition: { domestic: "€5,000+/yr", international: "€6,000–€9,000/yr" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "Diploma in IT", duration: "1 year", language: "English" },
      { name: "Business Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "80%", avgSalary: "€24,000–€36,000", topEmployers: ["SMEs", "Support Services"] },
    intakes: ["Multiple"], istpStudents: 3,
  },

  "european-graduate-school-malta": {
    slug: "european-graduate-school-malta", country: "malta",
    name: "European Graduate School Malta", shortName: "EGS Malta", flag: "🇲🇹",
    city: "Valletta", founded: 1994, qsRank: "#Specialised Institute",
    heroImg:
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",
    overview: "Niche postgraduate institution in arts, philosophy, and humanities.",
    tuition: { domestic: "€7,000+/yr", international: "€8,000–€14,000/yr" },
    living: "€750–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MA Humanities", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "78%", avgSalary: "Sector Dependent", topEmployers: ["Academic / Creative Fields"] },
    intakes: ["October"], istpStudents: 1,
  },

  "sts-education-malta": {
    slug: "sts-education-malta", country: "malta",
    name: "STS Education Malta", shortName: "STS", flag: "🇲🇹",
    city: "St. Julian's", founded: 1984, qsRank: "#Language & Higher Education",
    heroImg:
      "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1498079022511-d15614cb1c02?q=80&w=900&auto=format&fit=crop",

    overview: "Popular pathway and English-language preparatory institution.",
    tuition: { domestic: "€4,000+/yr", international: "€5,000–€8,000/yr" },
    living: "€700–€1,000/mo", ielts: "Varies", gre: "Not Required",
    topCourses: [
      { name: "Foundation Studies", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "82%", avgSalary: "Varies", topEmployers: ["Service Sector"] },
    intakes: ["Multiple"], istpStudents: 2,
  },

  "institute-of-tourism-studies-malta": {
    slug: "institute-of-tourism-studies-malta", country: "malta",
    name: "Institute of Tourism Studies Malta", shortName: "ITS Malta", flag: "🇲🇹",
    city: "Luqa", founded: 1987, qsRank: "#Sector Institute",
    heroImg:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?q=80&w=900&auto=format&fit=crop",
    overview: "Leading institution for hospitality, tourism, and hotel management.",
    tuition: { domestic: "€3,000+/yr", international: "€5,000–€9,000/yr" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "BA Hospitality Management", duration: "3 years", language: "English" },
      { name: "Diploma Tourism Studies", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€24,000–€38,000", topEmployers: ["Hilton", "Marriott", "Tourism Firms"] },
    intakes: ["October", "February"], istpStudents: 5,
  },
};